import React from 'react'
import Style from './searchBar.module.css'

const SearchBar = ({ value, onChange, placeholder, label, className }) => (
    <div className={[Style.search, className].filter(Boolean).join(' ')} role="search">
        <i className={`uil-search ${Style.icon}`} aria-hidden="true" />
        <input
            type="search"
            className={Style.input}
            value={value}
            placeholder={placeholder}
            aria-label={label || placeholder}
            onChange={(event) => onChange(event.target.value)}
        />
        {value ? (
            <button type="button" className={Style.clear} aria-label="Clear search" onClick={() => onChange('')}>
                <i className="uil-times" aria-hidden="true" />
            </button>
        ) : null}
    </div>
)

export default SearchBar
